import * as React from 'react';
import { Icon } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
export let ActionIconName = /*#__PURE__*/function (ActionIconName) {
  ActionIconName["Create"] = "AddTo";
  ActionIconName["Delete"] = "Delete";
  ActionIconName["Edit"] = "Edit";
  ActionIconName["Copy"] = "Copy";
  ActionIconName["Archive"] = "Archive";
  ActionIconName["Unarchive"] = "GiftboxOpen";
  ActionIconName["Download"] = "DrillDown";
  ActionIconName["Move"] = "Move";
  ActionIconName["Grab"] = "GlobalNavButton";
  ActionIconName["ChevronDown"] = "ChevronDown";
  ActionIconName["ChevronUp"] = "ChevronUp";
  ActionIconName["ChevronRight"] = "ChevronRight";
  ActionIconName["Close"] = "Cancel";
  ActionIconName["Plus"] = "CalculatorAddition";
  ActionIconName["Minus"] = "CalculatorSubtract";
  ActionIconName["Sort"] = "Sort";
  ActionIconName["SortDesc"] = "SortDown";
  ActionIconName["SortAsc"] = "SortUp";
  ActionIconName["Comment"] = "Comment";
  ActionIconName["ActiveComment"] = "CommentActive";
  ActionIconName["SolidComment"] = "CommentSolid";
  ActionIconName["FilterOn"] = "FilterSolid";
  ActionIconName["FilterOff"] = "Filter";
  ActionIconName["Star"] = "FavoriteStarFill";
  ActionIconName["Notes"] = "DietPlanNotebook";
  return ActionIconName;
}({});
export let ActionIconSize = /*#__PURE__*/function (ActionIconSize) {
  ActionIconSize[ActionIconSize["Tiny"] = 11] = "Tiny";
  ActionIconSize[ActionIconSize["Small"] = 14] = "Small";
  ActionIconSize[ActionIconSize["Medium"] = 18] = "Medium";
  ActionIconSize[ActionIconSize["Large"] = 32] = "Large";
  return ActionIconSize;
}({});
export const ActionIcon = /*#__PURE__*/React.memo(_ref => {
  let {
    actionName,
    size
  } = _ref;
  return /*#__PURE__*/_jsx(Icon, {
    iconName: actionName,
    style: {
      fontSize: size
    }
  });
});